/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFireHydrant = createReactComponent("outline", "fire-hydrant", "IconFireHydrant", [["path", { "d": "M5 21h14", "key": "svg-0" }], ["path", { "d": "M17 21v-5h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -10 0v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5", "key": "svg-1" }], ["path", { "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8h12", "key": "svg-3" }]]);

export { IconFireHydrant as default };
//# sourceMappingURL=IconFireHydrant.mjs.map
